import { useRef, useEffect, useState } from 'react';
import { Modal, Form, Input, Select, notification, Button, Space } from 'antd';
import {
    useCreatePendingClientMutation,
    useGetCustomerNameMutation,
} from '../../features/api/apiSlice';
function ClientCreateModal({ open, setOpen, billingUserData, kaUserData }) {
    const [form] = Form.useForm();
    const uidInputRef = useRef();
    const [createClient, { isError, isLoading, error, isSuccess }] = useCreatePendingClientMutation();
    const [showInput, setShowInput] = useState(false);
    const [get_customer_name, {
        data: responseData,
        isLoading: GetCustomerNameLoading,
        isSuccess: GetCustomerNameSuccess,
        isError: GetCustomerNameIsError,
        error: GetCustomerNameError,
    }] = useGetCustomerNameMutation();
    const handleCancel = () => {
        setOpen(false);
    }
    useEffect(() => {
        if (isError) {
            if (error.data && 'uid' in error.data) {
                notification.error({
                    message: "Error",
                    description: "客户ID已存在",
                });
            } else if (error.data && "non_field_errors" in error.data) {
                notification.error({
                    message: "Error",
                    description: error.data.non_field_errors,
                });
            } else {
                notification.error({
                    message: "Error",
                    description: "Unknown error",
                });
            }
            uidInputRef.current.select();
        }
    }, [isError])
    useEffect(() => {
        if (isSuccess) {
            notification.success({
                message: "Success",
                description: "新建客户已提交审核, 请等待审核通过",
            });
            setOpen(false);
            form.resetFields();
        }
    }, [isSuccess])
    useEffect(() => {
        if(GetCustomerNameSuccess){
            if (responseData.user_name) {

                setShowInput(true)
                form.setFieldsValue({
                    username: responseData.user_name
                });
            }
        }
        if(GetCustomerNameError && GetCustomerNameIsError){
            console.log("error", GetCustomerNameError)
            notification.error({
                description: GetCustomerNameError.data.error,
                message: "Error"
            })
        }
    }, [GetCustomerNameSuccess, GetCustomerNameError, responseData, setShowInput, GetCustomerNameError, GetCustomerNameIsError]);
    const handleOk = () => {
        form.validateFields().then(values => {
            const data = {
                uid: values.uid,
                username: values.username,
                user: values.userAssignedTo,
                contact: values.contact,
                rate_template: values.rateTemplate,
                business_type: values.businessType,
                billing_cycle: values.billingCycle,
                credit_line: values.creditLine,
                comments1: values.comments1,
                currency: values.currency,
            }
            createClient(data);
        }).catch((info) => {
            console.log("Validate Failed:", info);
        });
    }
    const NumberOnly = (rule, value, callback) => {
        return new Promise((resolve, reject) => {
            if (value && !/^[a-zA-Z0-9]+$/.test(value)) {
                reject('Please input combination of numbers and characters only!');
            } else {
                resolve();
            }
        });
    }
    const PositiveNumberOnly = (rule, value, callback) => {
        return new Promise((resolve, reject) => {
            if (value && !/^[0-9]+(.[0-9]{1,2})?$/.test(value)) {
                reject('请输入可识别的正数, 最多两位小数!');
            } else if (value && value.length > 20) {
                reject('最多20位!');
            } else {
                resolve();
            }
        });
    }
    const handleGetCustomerName = async () => {
        try {
            const uid = form.getFieldValue('uid');

            if (!uid) {
                notification.info({
                    description: "请输入uid",
                    message: "Info"
                });
                return;
            }
            // 获取客户名
            get_customer_name({user_id: uid})

        } catch (error) {
            console.error('请求失败:', error);
            notification.error({
                message: "错误",
                description: error.data?.message || "获取客户信息失败"
            });
        }
    };
    return (
        <Modal title="添加新客户" open={open} onOk={handleOk} onCancel={handleCancel} confirmLoading={isLoading}>
            <Form
                form={form}
                labelCol={{
                    span: 5,
                }}
                wrapperCol={{
                    span: 19,
                }}
                style={{ marginTop: '20px', maxWidth: '100%' }}>
                <Form.Item
                    name="uid"
                    label="UID"
                    rules={[
                        {
                            required: true,
                            message: '请填写客户ID!'
                        }, {
                            validator: NumberOnly,
                            message: '仅支持数字格式'
                        }
                    ]}
                    validateTrigger="onSubmit">
                    <Space.Compact style={{ width: '100%' }}>
                        <Input
                            disabled={showInput}
                            ref={uidInputRef}
                        />
                        <Button
                            type="primary"
                            style={{ width: '80px' }}
                            onClick={handleGetCustomerName}
                            loading={GetCustomerNameLoading}
                        >
                            获取客户名
                        </Button>
                        <Button
                            style={{ width: '80px' }}
                            onClick={() => { 
                                form.resetFields(['uid', 'username', 'contact', 'userAssignedTo', 'businessType', 'billingCycle', 'creditLine', 'comments1', 'currency']);
                                setShowInput(false);
                            }}
                        >
                            重置
                        </Button>

                    </Space.Compact>
                </Form.Item>
                <Form.Item name="username" label="客户名" rules={[{ required: true, message: '请填写客户名!' }]} style={{
                    display: showInput ? 'block' : 'none'
                }}>
                    <Input disabled/>
                </Form.Item>
                <Form.Item name="contact" label="客户对接人" rules={[{ required: true, message: '请填写客户对接人!' }]} style={{
                    display: showInput ? 'block' : 'none'
                }}>
                    <Select allowClear
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }>
                        {kaUserData && kaUserData.map(user => (
                            <Select.Option key={user.id} value={user.id}>
                                {user.username}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item name="userAssignedTo" label="账单负责人" rules={[{ required: true, message: '请选择账单负责人!' }]} style={{
                    display: showInput ? 'block' : 'none'
                }}>
                    <Select
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }>
                        {billingUserData && billingUserData.map(user => (
                            <Select.Option key={user.id} value={user.id}>
                                {user.username}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item name="businessType" label="业务类型" rules={[{ required: true, message: '请选择业务类型!' }]} style={{
                    display: showInput ? 'block' : 'none'
                }}>
                    <Select allowClear>
                        <Select.Option value="渠道">渠道</Select.Option>
                        <Select.Option value="转运">转运</Select.Option>
                        <Select.Option value="代发">代发</Select.Option>
                        <Select.Option value="提柜">提柜</Select.Option>
                        <Select.Option value="海运">海运</Select.Option>
                        <Select.Option value="清派">清派</Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item name="billingCycle" label="账期" rules={[{ required: true, message: '请选择账期!' }]} style={{
                    display: showInput ? 'block' : 'none'
                }}>
                    <Select>
                        <Select.Option value="0">0 天</Select.Option>
                        <Select.Option value="7">7 天</Select.Option>
                        <Select.Option value="15">15 天</Select.Option>
                        <Select.Option value="25">25 天</Select.Option>
                        <Select.Option value="30">30 天</Select.Option>
                        <Select.Option value="60">60 天</Select.Option>
                        <Select.Option value="90">90 天</Select.Option>
                        <Select.Option value="预充">预充</Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item name="currency" label="币种" rules={[{ required: true, message: '请选择币种!' }]} style={{
                    display: showInput ? 'block' : 'none'
                }}>
                    <Select>
                        <Select.Option label='USD' key='0' value='0'>USD</Select.Option>
                        <Select.Option label='CNY' key='1' value='1'>CNY</Select.Option>
                        <Select.Option label='EUR' key='2' value='2'>EUR</Select.Option>
                        <Select.Option label="CAD" key='3' value='3'>CAD</Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item name="creditLine" label="客户授信额度" rules={[{ validator: PositiveNumberOnly }]} style={{
                    display: showInput ? 'block' : 'none'
                }}>
                    <Input />
                </Form.Item>
                <Form.Item name="comments1" label="备注" style={{
                    display: showInput ? 'block' : 'none'
                }}>
                    <Input.TextArea />
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default ClientCreateModal;